import * as React from 'react';
import { Header1 } from '@cian/ui-kit';

import { IInteriorDecoration } from '../../types/newbuilding/interiorDecoration';
import { VerticalSlider } from '../VerticalSlider';
import { Arrow } from './parts/Arrow';
import { InteriorDecorationItem } from './parts/InteriorDecorationItem';

import * as styles from './styles.css';

interface IInteriorDecorationProps {
  items: IInteriorDecoration[];
  onItemClick(i: number): void;
}

export function InteriorDecoration({ items, onItemClick }: IInteriorDecorationProps) {
  return (
    <div data-nav-tab="decorations/Варианты отделки" id="decorations" className={styles['nav_container']}>
      <div className={styles['header']}>
        <Header1 as="h2" fontWeight="bold">
          Варианты отделки от застройщика
        </Header1>
      </div>
      <div className={styles['container']}>
        <VerticalSlider containerClass={styles['slider']} onItemClick={onItemClick} arrow={Arrow}>
          {items.map(({ title, images, shortDescription }) => {
            const { thumbnailUrl, url } = images[0];

            return (
              <InteriorDecorationItem
                key={title}
                title={title}
                imgUrl={thumbnailUrl || url}
                shortDescription={shortDescription}
              />
            );
          })}
        </VerticalSlider>
      </div>
    </div>
  );
}
